import React from 'react';

import {withStyles, Typography, Divider, Grid, List, ListItem, ListItemText} from '@material-ui/core';
import styles from '../config/styles';
import facebook from '../assets/facebook.png';
import gplus from '../assets/gplus.png';
import twitter from '../assets/twitter.png';

import Subscribe from './subscribe';

class Footer extends React.Component{
    render(){
        const {classes} = this.props;
        return(
            <section className={classes.section}>
                <Subscribe />
                <div className={classes.innerBox}>
                    <Grid container className={classes.contactUsContainer}>
                        <Grid item xs={5} sm={3} md={3} lg={3}>
                            <Typography variant="h5" align='center' gutterBottom>
                                    Who we are
                            </Typography>
                            <List dense={true}>
                                <ListItem >
                                    <ListItemText style={{textAlign:'center'}}>
                                        <a href="#aboutUs" className={classes.itemLink}>About Us</a>
                                    </ListItemText>
                                </ListItem>
                                <ListItem>
                                    <ListItemText style={{textAlign:'center'}}>
                                        <a href="https://getriku.zohorecruit.in/jobs/2021" target="_blank" className={classes.itemLink}>Careers</a>
                                    </ListItemText>                                
                                </ListItem>
                                <ListItem>
                                    <ListItemText style={{textAlign:'center'}}>
                                        <a href="#projects" className={classes.itemLink}>Projects</a>
                                    </ListItemText>
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={5} sm={3} md={3} lg={3}>
                            <Typography variant="h5" align='center' gutterBottom>
                                    Support
                            </Typography>
                            <List dense={true}>
                                <ListItem>
                                    <ListItemText style={{textAlign:'center'}}>
                                        <a href="https://medium.com/futuristiclabs" target="_blank" className={classes.itemLink}>Blog</a>
                                    </ListItemText>
                                </ListItem>
                                <ListItem>
                                    <ListItemText style={{textAlign:'center'}}>
                                        <a href="#tos" className={classes.itemLink}>Terms of use</a>
                                    </ListItemText>
                                </ListItem>
                                <ListItem>
                                    <ListItemText style={{textAlign:'center'}}>
                                        <a href="#bug" className={classes.itemLink}>Report a Bug</a>
                                    </ListItemText>
                                </ListItem>
                            </List>
                        </Grid>
                        <Grid item xs={5} sm={3} md={3} lg={3}>
                            <Typography variant="h5" align='center' gutterBottom>
                                Contact Us
                            </Typography>
                            <Typography variant="subtitle1" align='center' style={{paddingTop:"4px"}}>
                                hello@ftlabs.io
                            </Typography>
                            <Typography variant="subtitle2" align='center' style={{paddingTop:"4px",color:'#5e6977'}}>
                            1st Floor, Plot No 62,<br/>
                            Jayabheri Enclave,<br/>
                            Gachibowli, Hyderabad, <br/>
                            Telangana 500032.<br/>
                            India
                            </Typography>
                        </Grid>
                        <Grid item xs={5} sm={3} md={3} lg={3}>
                            <Typography variant="h5" align='center' gutterBottom>
                                Follow us
                            </Typography>
                            <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}> 
                                <a href="https://facebook.com/getRiku" style={{textDecoration: "none"}}> 
                                    <img src={facebook} className={classes.socialIcons} alt="https://facebook.com/getRiku" />
                                </a>
                                <a href="http://getriku.com" style={{textDecoration: "none"}}>
                                    <img src={gplus} className={classes.socialIcons} alt="http://getriku.com" />
                                    </a>
                                <a href="https://twitter.com/iamrikuai" style={{textDecoration: "none"}}>
                                    <img src={twitter} className={classes.socialIcons}  alt="https://twitter.com/iamrikuai" />
                                </a>


                            </div>
                        </Grid>
                    </Grid>
                </div>
                <Divider style={{"margin": "20px"}} />
                <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>

                <Typography variant="caption" style={{textAlign:"center",color:'#5e6977'}}>
                    Copyright © {new Date().getFullYear()} Futuristic Labs Private Limited
                </Typography>
                </div>
            </section>
        )
    }
}

export default withStyles(styles)(Footer);